import { useRef, useEffect } from "react";

export const useCallSounds = () => {
  const startSound = useRef<HTMLAudioElement>(
    new Audio(
      new URL("../../assets/sounds/start_call.mp3", import.meta.url).href,
    ),
  );

  const ringingSound = useRef<HTMLAudioElement>(
    new Audio(
      new URL(
        "../../assets/sounds/call_ringing_repeat_me.mp3",
        import.meta.url,
      ).href,
    ),
  );

  const connectedSound = useRef<HTMLAudioElement>(
    new Audio(
      new URL(
        "../../assets/sounds/call_started_talk_now.mp3",
        import.meta.url,
      ).href,
    ),
  );

  const endSound = useRef<HTMLAudioElement>(
    new Audio(
      new URL("../../assets/sounds/end_call.mp3", import.meta.url).href,
    ),
  );

  useEffect(() => {
    if (ringingSound.current) {
      ringingSound.current.loop = true;
    }
  }, []);

  const stopAllSounds = () => {
    [startSound, ringingSound, connectedSound, endSound].forEach((audioRef) => {
      const audio = audioRef.current;
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    });
  };

  const playSound = async (audioRef: typeof startSound) => {
    try {
      if (audioRef === ringingSound && !ringingSound.current?.paused) return;

      stopAllSounds();

      const audio = audioRef.current;
      if (audio) {
        await new Promise<void>((resolve) => {
          setTimeout(resolve, 50);
        });
        audio.currentTime = 0;
        await audio.play();
      }
    } catch (error) {
      console.log("Error playing sound:", error);
    }
  };

  return {
    startSound,
    ringingSound,
    connectedSound,
    endSound,
    playSound,
    stopAllSounds,
  };
};
